(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-section-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $slider = $('.review_slide');
    var cardSelector = '.single_review';
    var cachedCards = [];

    function cacheCards() {
      cachedCards = [];
      $slider.find(cardSelector).each(function () {
        cachedCards.push(this.cloneNode(true));
      });
    }

    function toChunks(arr, size) {
      var out = [];
      for (var i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    }

    function buildSlides(cards) {
      var slides = [];
      toChunks(cards, 3).forEach(function (chunk) {
        var slide = document.createElement('div');
        slide.className = 'item';
        chunk.forEach(function (card) {
          slide.appendChild(card);
        });
        slides.push(slide);
      });
      return slides;
    }

    function mountFromCards(cards) {
      if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
      $slider.empty();
      buildSlides(cards).forEach(function (n) {
        $slider.append(n);
      });
      if ($slider.children().length) {
        $slider.slick({
          infinite: true,
          slidesToShow: 1,
          dots: true,
          customPaging: function (slick, index) {
            return '<a>' + (index + 1) + '</a>';
          },
          responsive: [
            { breakpoint: 992, settings: { slidesToShow: 1 } },
            { breakpoint: 640, settings: { slidesToShow: 1 } }
          ]
        });
      }
    }

    function filterCardsByProductId(productId) {
      var source = cachedCards;
      if (!productId)
        return source.map(function (n) {
          return n.cloneNode(true);
        });
      return source
        .filter(function (n) {
          return n.getAttribute('data-product-id') === productId;
        })
        .map(function (n) {
          return n.cloneNode(true);
        });
    }

    function applyFilter(productId) {
      var filtered = filterCardsByProductId(productId);
      mountFromCards(filtered);
      if (filter) filter.value = productId || '';
      if (list) {
        var pid = productId || '';
        list.querySelectorAll('li').forEach(function (li) {
          var id = li.getAttribute('data-id') || '';
          li.classList.toggle('active', id === pid);
        });
      }
    }

    cacheCards();
    mountFromCards(
      cachedCards.map(function (n) {
        return n.cloneNode(true);
      })
    );

    var filter = document.getElementById('reviewsProductFilter');
    var list = document.querySelector('.reviews-list');

    if (filter) {
      filter.addEventListener('change', function () {
        applyFilter(filter.value);
      });
    }

    if (list) {
      list.addEventListener('click', function (e) {
        var li = e.target.closest('li');
        if (!li || !list.contains(li)) return;
        var id = li.getAttribute('data-id') || '';
        applyFilter(id);
      });
    }

    // Keep UI in sync if breakpoint switches
    window.addEventListener('resize', function () {
      if (!filter || !list) return;
      // When moving between mobile and desktop, ensure both controls reflect the same value
      var activeLi = list.querySelector('li.active');
      var currentId = activeLi ? activeLi.getAttribute('data-id') || '' : (filter.value || '');
      applyFilter(currentId);
    });

    // Public helpers for debugging
    window.__reviewsSlides = {
      allCards: function () {
        return cachedCards.map(function (n) {
          return n.cloneNode(true);
        });
      },
      rebuild: function (cards) {
        mountFromCards(
          cards ||
            cachedCards.map(function (n) {
              return n.cloneNode(true);
            })
        );
      },
      filterCardsByProductId: filterCardsByProductId,
      applyFilter: applyFilter
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
